import React from 'react';
import BaseField, { BaseFieldProps } from '../BaseField/BaseField';
import Code, { CodeInputType } from './Code';

interface Props extends BaseFieldProps {
	length: number;
	type?: CodeInputType;
	onChange?: (value: string) => void;
	autoFocus?: boolean;
}

const CodeField: React.FC<Props> = props => {
	return (
		<BaseField {...props}>
			<Code
				length={props.length}
				type={props.type}
				onChange={props.onChange}
				autoFocus={props.autoFocus}
				disabled={props.disabled}
			/>
		</BaseField>
	);
};

export default CodeField;
